export const Dot = ({size = 5, fill = '#030412'}) => (
  <svg height={`${size}px`} width={`${size}px`}>
    <circle
    cx={size / 2}
    cy={size / 2}
    r={size / 2}
    fill={fill}
    />
  </svg>
)